import React from "react";

const SIZES = {
  sm: { h: 150, gap: 6, titleSize: 15, valSize: 11 },
  md: { h: 180, gap: 10, titleSize: 16, valSize: 12 },
};

/**
 * Bar chart by cycle ("Wellness Trend"): hatched ongoing bar and dashed
 * average line. Plain positioned divs, as in the design.
 *
 * @param {Object} props
 * @param {Object} props.trend - From core/model/metrics/shared.bars + title/scope/legend/note.
 * @param {'sm'|'md'} [props.size]
 */
const WellnessTrend = ({ trend, size = "md" }) => {
  const v = SIZES[size];
  return (
    <div className="flex flex-col gap-[14px] min-w-0">
      <div className="flex justify-between items-start gap-[16px] flex-wrap">
        <div className="flex flex-col gap-[3px] min-w-0">
          <span className="font-bold tracking-[-0.01em]" style={{ fontSize: v.titleSize }}>
            {trend.title}
          </span>
          <span className="text-[12px] text-[#6b6b6b]">{trend.scope}</span>
        </div>
        <div className="flex flex-wrap gap-x-[16px] gap-y-[8px] text-[11px] text-[#555]">
          {trend.legend.map((l) => (
            <span key={l.label} className="flex items-center gap-[6px]">
              <span className="rounded-[2px] box-border" style={{ width: l.w, height: l.h, background: l.bg, border: l.border }} />
              {l.label}
            </span>
          ))}
        </div>
      </div>

      <div className="relative ml-[30px]" style={{ height: v.h }}>
        {trend.ticks.map((t) => (
          <React.Fragment key={t.label}>
            <div className="absolute left-0 right-0 border-t border-[#F1ECE8]" style={{ bottom: t.b }} />
            <div
              className="absolute left-[-30px] w-[24px] text-right translate-y-1/2 text-[10px] text-[#A39A93] tabular-nums"
              style={{ bottom: t.b }}
            >
              {t.label}
            </div>
          </React.Fragment>
        ))}
        <div className="absolute left-0 right-0 flex h-full" style={{ gap: v.gap }}>
          {trend.bars.map((b, i) => (
            <div key={`${b.label}-${i}`} className="flex-1 relative h-full min-w-0">
              <div
                className="absolute bottom-0 left-[22%] right-[22%] box-border rounded-t-[4px]"
                style={{ height: b.h, background: b.bg, border: b.border }}
              />
              <div
                className="absolute left-0 right-0 text-center font-bold tabular-nums text-[#1f1f1f]"
                style={{ bottom: b.labB, fontSize: v.valSize }}
              >
                {b.vTxt}
              </div>
              <div className="absolute left-0 right-0 bottom-[6px] text-center text-[10px] leading-[1.3] text-[#8a8a8a] px-[4px]">
                {b.emptyTxt}
              </div>
            </div>
          ))}
        </div>
        <div
          className="absolute left-0 right-0 border-t-[1.5px] border-dashed border-[#3a3a3a]"
          style={{ bottom: trend.avgB, opacity: trend.avgOp }}
        />
        <div
          className="absolute right-0 -translate-y-[3px] text-[10px] font-bold text-[#3a3a3a] bg-white px-[4px]"
          style={{ bottom: trend.avgB, opacity: trend.avgOp }}
        >
          {trend.avgTxt}
        </div>
      </div>

      <div className="flex ml-[30px]" style={{ gap: v.gap }}>
        {trend.bars.map((b, i) => (
          <div key={`${b.label}-${i}`} className="flex-1 min-w-0 flex flex-col items-center gap-[1px] text-center">
            <span className="text-[11px] font-bold text-[#3a3a3a]">{b.label}</span>
            <span className="text-[10px] text-[#8a8a8a] whitespace-nowrap">{b.sub}</span>
          </div>
        ))}
      </div>
      {trend.hasNote && <span className="text-[11px] text-[#8a8a8a]">{trend.note}</span>}
    </div>
  );
};

export default WellnessTrend;
